import { useState } from "react";
import PageTitle from "../../../../components/PageTitle";
import api from "../../../../services/api";
import Style from "./CreatePaymentOptionStyle";

export default function CreatePaymentOption(props)
{
    const [name, setName] = useState("");
    const [dates, setDates] = useState<number[]>([])
    const monthDays = Array.from(Array(31).keys());

    async function OnSubmit() {
        let paymentOptionId;
        try {
            if (name === "") {
                return
            }

            const result = await api.post(`/enterprises/${props.match.params.enterpriseId}/paymentOption`,  {name})
            paymentOptionId = parseInt(result.data.paymentOption.id)
            await api.post(`/enterprises/${props.match.params.enterpriseId}/paymentOption/dates`, {dates, paymentOptionId})
            return result;
        }
        catch (error) {
            console.log(error);
        }
        finally {
            props.history.push(`${paymentOptionId}`)
        }
    }

    function AddDate(n: number) {
        const newDates = [...dates, n].sort((a, b) => a - b);
        setDates(newDates)
    }

    function RemoveDate(n: number) {
        const newDates = dates.filter(value => value !== n).sort((a, b) => a - b);
        setDates(newDates);
    }

    return(
        <Style className="default-page">
            <PageTitle title="Criar opção de pagamento"/>
            <div>
                <button onClick={() => props.history.goBack()} className="btn-secondary go-back">Voltar</button>
            </div>
            <main className="default-main">
                <div className="panel">
                    <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
                        <h2>Criação de opção de pagamento</h2>
                        <div>
                            <label>Nome:</label>
                            <input
                                type="text"
                                value={name}
                                placeholder={"Opção de pagamento"}
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>Datas de pagamento:</label>
                            <div className="payment-dates">
                                {monthDays.map((day, index) => {
                                    return(
                                        <button 
                                            key={index}
                                            className={(dates.includes(day+1) ? "btn-primary" : "btn-secondary") + " btn btn-date"}
                                            onClick={() => dates.includes(day+1) ? RemoveDate(day+1) : AddDate(day+1)}>
                                            {day+1}
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                        <button
                            className="btn btn-success btn-lg mt-4"
                            type="button"
                            disabled={!name}
                            onClick={e => { e.preventDefault(); OnSubmit()}
                        }>Adicionar</button>
                    </form>
                </div>
            </main>
        </Style>
    )
}